import React, { useContext, useEffect, useState } from 'react';
import { BooleanSelector } from 'components/selectors/booleanSelector';
import { ColorScalesContext } from 'views/common/colorScalesContext';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';


export default function ColorByValuesSelector(props) {
	const colorChain = useContext(ColorScalesContext);

	const {widgetConfiguration, cardIndex, type } = props;

	const { dispatch } = useContext(WorkspaceContext);
	const [disableBoolean, setBooleanDisabled] = useState(false);

	useEffect(() => {
		const c = colorChain.execute(type, widgetConfiguration.colorScale);
		switch (c.scaleType) {
			case "quantile":
				const configuration = JSON.parse(JSON.stringify(widgetConfiguration));
				configuration["colorByValue"] = true;
				dispatch(WorkspaceActionCreator.configuration(cardIndex, configuration));
				setBooleanDisabled(true);
				break;
			default:
				setBooleanDisabled(false);
		}
	}, [widgetConfiguration.colorScale, type]);



	return <BooleanSelector {...props} disabled={disableBoolean}/>
}
